import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { IProviderInfo } from '../../../../../../../types/stockOrders';
import './ProviderInfo.scss';

const ProviderInfo = ({ providerInfo, setSelectedTabId }: { providerInfo: IProviderInfo, setSelectedTabId: (tabId: number) => void }) => {
  return (
    <div className="providerInfo">
      <span className="providerInfoTitle">Información del proveedor</span>
      <div className="providerInfoContainer">
        <div>
          <div className="providerInfoLabel">Nombre del Proveedor</div>
          <div className="providerInfoValue">{providerInfo.name}</div>
        </div>
        <div>
          <div className="providerInfoLabel">N° de orden de proveedor</div>
          <div className="flex items-center gap-8">
            <div className="providerInfoValue">{providerInfo.orderNumber}</div>
            <div className="providerInfoEdit" onClick={() => setSelectedTabId(2)}>
              <span>Editar</span>
              <BordOneToneIcon variant="edit" standardSize={16} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderInfo;
